var map = {
	"./agv.jpg": "f39d",
	"./agv_EN.jpg": "6084",
	"./deliveryIndustrySolution.jpg": "1f87",
	"./deliveryIndustrySolution_EN.jpg": "59e5",
	"./electricalBike.jpg": "e4ff",
	"./electricalBike_EN.jpg": "2d9c",
	"./electricalFourWheel.jpg": "d444",
	"./electricalFourWheel_EN.jpg": "a27e",
	"./electricalMoto.jpg": "081c",
	"./electricalMoto_EN.jpg": "63f9",
	"./electricalThreeWheel.jpg": "a78d",
	"./electricalThreeWheel_EN.jpg": "517a",
	"./parkIndustrySolution.jpg": "7ede",
	"./parkIndustrySolution_EN.jpg": "f381",
	"./policeIndustrySolution.jpg": "db8c",
	"./policeIndustrySolution_EN.jpg": "83c6",
	"./shippingIndustrySolution.jpg": "a0ad",
	"./shippingIndustrySolution_EN.jpg": "6c32"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "912f";